var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#888B8D",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M9.403 17.625c5.283 0 8.172-4.232 8.172-7.9 0-.121-.002-.24-.008-.36.56-.392 1.048-.88 1.433-1.438-.515.221-1.069.37-1.65.437.594-.343 1.049-.887 1.263-1.536-.555.318-1.17.55-1.823.674-.524-.54-1.27-.877-2.097-.877-1.586 0-2.873 1.244-2.873 2.777 0 .218.026.43.075.633-2.387-.116-4.504-1.221-5.92-2.901-.248.41-.39.887-.39 1.395 0 .964.508 1.814 1.279 2.312-.472-.014-.914-.14-1.301-.348l-.001.036c0 1.345.99 2.468 2.304 2.722-.24.064-.495.098-.757.098-.185 0-.365-.018-.54-.05.366 1.103 1.426 1.906 2.684 1.928-.984.745-2.222 1.19-3.568 1.19-.232 0-.46-.014-.685-.04 1.271.788 2.78 1.248 4.403 1.248"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.7a40a018.svg";
export { ForwardRef as ReactComponent };